import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_BEGIN,
  REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_SUCCESS,
  REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_FAILURE,
  REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function fetchOosAccountAccountType(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "ascend",
          sortedBy: "site",
        }
      }
      const doRequest = axios.post(`${API_REQUEST_URL}/getOosAccountAccountType`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_SUCCESS,
            data: {
              data: res.data.data,
              totals: res.data.totals,
              summary: res.data && res.data.summary,
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchOosAccountAccountTypeError() {
  return {
    type: REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_DISMISS_ERROR,
  };
}

export function useFetchOosAccountAccountType() {
  const dispatch = useDispatch();

  const {reportsData, summary, reportsTotals, fetchOosAccountAccountTypePending, fetchOosAccountAccountTypeError } = useSelector(
    state => ({
      reportsData: state.reports.reportsData,
      summary: state.reports.summary,
      reportsTotals: state.reports.reportsTotals,
      fetchOosAccountAccountTypePending: state.reports.fetchOosAccountAccountTypePending,
      fetchOosAccountAccountTypeError: state.reports.fetchOosAccountAccountTypeError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchOosAccountAccountType(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchOosAccountAccountTypeError());
  }, [dispatch]);

  return {
    reportsData, 
    summary, 
    reportsTotals,
    fetchOosAccountAccountType: boundAction,
    fetchOosAccountAccountTypePending,
    fetchOosAccountAccountTypeError,
    dismissFetchOosAccountAccountTypeError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchOosAccountAccountTypePending: true,
        fetchOosAccountAccountTypeError: null,
      };

    case REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_SUCCESS:
      // The request is success
      return {
        ...state,
        reportsData: action.data.data,
        reportsTotals: action.data.totals,
        summary: action.data.summary, 
        fetchOosAccountAccountTypePending: false,
        fetchOosAccountAccountTypeError: null,
      };

    case REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchOosAccountAccountTypePending: false,
        fetchOosAccountAccountTypeError: action.data.error,
      };

    case REPORTS_FETCH_OOS_ACCOUNT_ACCOUNT_TYPE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchOosAccountAccountTypeError: null,
      };

    default:
      return state;
  }
}
